import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table-v6';
import '../../../styles/custom.css';
import { CustomNoDataComponent, makeFirstLetterCapital } from '../../../utility/utility';
import { useSelector, useDispatch } from 'react-redux';
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import * as actions from '../../../redux/actions/index';
import ReactTooltip from 'react-tooltip';
import { MagicSpinner, PushSpinner, SwishSpinner, WaveSpinner, ClapSpinner } from 'react-spinners-kit';
import 'react-table-v6/react-table.css';
import ImageLoader from 'react-imageloader';
import { userRoles } from '../../../utility/constants/constants';
import storage from '../../../utility/storage';

const CompaniesTable = (props) => {
    const dispatch = useDispatch();
    const SearchValue = useSelector(state => state.adminOrSuperAdminReducer.companySearchValues);
    const DateGenerate = useSelector(state => state.adminOrSuperAdminReducer.dataGenerated);
    const SearchOrResetCompanyClicked = useSelector(state => state.adminOrSuperAdminReducer.SearchOrResetCompanyClicked);
    const No_of_pages = useSelector(state => state.adminOrSuperAdminReducer.company_page);
    const No_of_rows = useSelector(state => state.adminOrSuperAdminReducer.company_rows);
    const companyPage = useSelector(state => state.adminOrSuperAdminReducer.company_cur_page);
    const user = storage.get('user');
    const [pageSize, setPageSize] = useState(10);
    const getAccontsName = (accounts) => {

        return accounts && accounts.length > 0 && accounts.map((a, i) => {
            if ((accounts.length - 1) === i) {
                return a.name;
            } else {
                return a.name + ', ';
            }
        })
    }

    function preloader() {
        return <img style={{ height: '35px', width: '35px', borderRadius: '50px', float: 'left' }} src="/images/gif/giphy.gif" />;
    }

    useEffect(() => {
        if (SearchOrResetCompanyClicked) {
            dispatch(actions.resetSearchOrResetValue())
        } else {
        const account_no_of_rows = No_of_rows;
        const page = companyPage + 1;
        const sorted = [];
        const filtered = [];
        SearchValue.active = props.activeCompanies
        props.getCompanies(
            SearchValue,
            account_no_of_rows, page,
            sorted,
            filtered);
        }
      }, [props.activeCompanies]);

    function extractCompanyTier(company) {
        let tierText;
        switch (company) {
                case 0:
                    tierText = 'None Selected';
                    break;
                case 1:
                    tierText = 'Tier - A';
                    break;
                case 2:
                    tierText = 'Tier - B';
                    break;
                case 3:
                    tierText = 'Tier - C';
                    break;
                default:
                    tierText = 'Invalid Tier'; // or any other default text
            }
                return tierText;
    }

    const data = props.companiesList.map(company => {
        return {
            id: company ? company.id : '',
            number: company ? company.company_number : '',
            image:
                (company && company.photo_urls && company.photo_urls.small) ?
                    <ImageLoader
                        imgProps={{ style: { height: '35px', width: '35px', borderRadius: '50px', float: 'left' } }}
                        style={{ height: '35px', width: '35px', borderRadius: '50px', float: 'left' }}
                        src={company.photo_urls && company.photo_urls.small}
                        wrapper={React.createFactory('div')}
                        preloader={preloader}>
                        Image load failed!
                                    </ImageLoader>
                    :
                    (company.photo_urls && company.photo_urls.small) ?
                        <ImageLoader
                            imgProps={{ style: { height: '35px', width: '35px', borderRadius: '50px', float: 'left' } }}
                            style={{ height: '35px', width: '35px', borderRadius: '50px', float: 'left' }}
                            src={company.photo_urls && company.photo_urls.small}
                            wrapper={React.createFactory('div')}
                            preloader={preloader}>
                            Image load failed!
                                    </ImageLoader>
                        :
                        <img src="/customImages/user.png" style={{ height: '35px', width: '35px', borderRadius: '50px', float: 'left' }} />
            ,
            company: company ? makeFirstLetterCapital(company.name) : makeFirstLetterCapital(company.name),
            address: company ? company.address && company.address.formatted_address : '',
            // accounts: company ? getAccontsName(company.accounts) : getAccontsName(company.accounts),
            status: company ? makeFirstLetterCapital(company.active_status) : makeFirstLetterCapital(company.active_status),
            company_tier: extractCompanyTier(company.company_tier),
            os1:company && company?.os1 ? company.os1 ? "Yes" : "No" : 'No',
            actions: <>
                <span data-test="users_eye" data-tip="View\Associate Jobs" className="mr_20 account_edit_icn" onClick={() => props.previewCompanyClicked(company ? company : company)}><i className="fas fa-eye cst_icon mr-2" aria-hidden="true"></i></span>
                <ReactTooltip place="top" type="dark" effect="solid" />
                {user.role !== 'admin' ?<> <span data-test="users_edit" className="mr_20 account_edit_icn" onClick={() => props.editCompanyClicked(company ? company : company)}><i class="fa fa-pencil" aria-hidden="true"></i></span>
                <span data-test="users_trash" className="mr_20 account_edit_icn" onClick={() => props.handleClickDeleteModel(company ? company : company)}><i class="fa fa-trash" aria-hidden="true"></i></span> </> : ''}
            </>
        }
    })

    const columns = [
        // {
        //     Header: <><span>ID</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
        //     accessor: 'id',
        //     width: 135,
        //     show: props.companiesList.length !== 0,
        //     Filter: ({ filter, onChange }) => (
        //         <input
        //             onChange={event => onChange(event.target.value)}
        //             value={filter ? filter.value : ''}
        //             placeholder={'Search Account...'}
        //             className={'form-control input-modifier'}
        //         />
        //     ), // String-based value accessors!
        // },
         {
            Header: '',
            accessor: 'image', // String-based value accessors!,
            width: 40,
            filterable: false,
        }, {
            Header: <><span>Customer</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'company',
            width: 400,
            show: props.companiesList.length !== 0,
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                    placeholder={'Search Account...'}
                    className={'form-control input-modifier'}
                />
            ), // String-based value accessors!
        },{
            Header: <><span>Customer Number</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
            accessor: 'number',
            width: 200,
            show: props.companiesList.length !== 0,
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                    placeholder={'Search Account...'}
                    className={'form-control input-modifier'}
                />
            ), // String-based value accessors!
        }
        //  {
        //     Header: <><span>Address</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
        //     accessor: 'address',
        //     width: 250,
        //     show: props.companiesList.length !== 0,
        //     Filter: ({ filter, onChange }) => (
        //         <input
        //             onChange={event => onChange(event.target.value)}
        //             value={filter ? filter.value : ''}
        //             placeholder={'Search Account...'}
        //             className={'form-control input-modifier'}
        //         />
        //     ), // String-based value accessors!
        // }
        // , {
        //     Header: <><span>Jobs</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /></>,
        //     accessor: 'accounts',
        //     show: props.companiesList.length !== 0,
        //     width: 400,
        //     Filter: ({ filter, onChange }) => (
        //         <input
        //             onChange={event => onChange(event.target.value)}
        //             value={filter ? filter.value : ''}
        //             placeholder={'Search Account Number...'}
        //             className={'form-control input-modifier'}
        //         />
        //     ), // String-based value accessors!
        // }
        , {
            Header: <><span>Status</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'status',
            width: 300,
            show: props.companiesList.length !== 0,
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                    placeholder={'Search Name...'}
                    className={'form-control input-modifier'}
                />
            ), // String-based value accessors!
        }, {
            Header: <><span>Customer Tier</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'company_tier',
            width: 200,
            show: props.companiesList.length !== 0,
            Filter: ({ filter, onChange }) => (
                <input
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                    placeholder={'Search Name...'}
                    className={'form-control input-modifier'}
                />
            ), // String-based value accessors!
        }, 
        {
            Header: <><span>OS1</span> <FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
            accessor: 'os1',
            width: 200,
            show: props.companiesList.length !== 0,
            // Filter: ({ filter, onChange }) => (
            //     <input
            //         onChange={event => onChange(event.target.value)}
            //         value={filter ? filter.value : ''}
            //         placeholder={'Search Name...'}
            //         className={'form-control input-modifier'}
            //     />
            // ), // String-based value accessors!
        },  
        {
            Header: '',
            accessor: 'actions',
            width: 135,
            filterable: false,
            // show: false
        }
    ]

    const [tablePage, setTablePage] = useState(0)
    const tablePageNew =  React.useRef()
    
    if(companyPage !== tablePageNew.current) {
        tablePageNew.current = companyPage;
    }

    const setTablePageFn = (page) => {
        setTablePage(page)
        props.companyPageClicked(page)
        tablePageNew.current = page;
    }

    const fetchData = (state, instance) => {
       debugger;
        if (SearchOrResetCompanyClicked) {
            dispatch(actions.resetSearchOrResetValue())
        } else {
            if (!DateGenerate) {
                state.page = 2;
                const company_no_of_rows = state.pageSize;
                let page = tablePageNew.current >= 0 ? tablePageNew.current + 1 : companyPage + 1;
                if(No_of_rows != company_no_of_rows) {
                    page = 1;
                    setTablePageFn(0)
                }                
                const sorted = state.sorted;
                const filtered = state.filtered;
                SearchValue.active = props.activeCompanies
                if (props.user.role === userRoles.SUPER_ADMIN) {
                    props.getCompanies(
                        SearchValue,
                        company_no_of_rows, page,
                        sorted,
                        filtered);
                }
                 else if(props.user.role === userRoles.ADMIN) {
                    props.getCompanies(
                        SearchValue,
                        company_no_of_rows, page,
                        sorted,
                        filtered);

                }
            }
            // }
        }
    }

    return (
        SearchOrResetCompanyClicked && props.isCompanyPending ?
            <div className="loader_btn_block">
                <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
            </div>
            :
            <ReactTable
                data={data}
                loading={props.isCompanyPending}
                defaultPageSize={No_of_rows?No_of_rows:pageSize}
                minRows={0}
                manual
                onFetchData={fetchData}
                pages={No_of_pages}
                gotoPage={companyPage}
                page = {
                    companyPage
                }
                showPaginationTop={true}
                onPageSizeChange={(e) => setPageSize(e)}
                onPageChange={(page) => {setTablePageFn(page)}}
                NoDataComponent={() => CustomNoDataComponent(props.isCompanyPending, 'No Companies Found')}
                showPagination={props.companiesList.length !== 0}
                // filterable={true}
                
                columns={columns}
                LoadingComponent={() =>
                    props.isCompanyPending ?
                        <div style={{
                            display: "block",
                            position: "absolute",
                            left: 0,
                            height: '100%',
                            right: 0,
                            background: "rgba(255,255,255,0.8)",
                            transition: "all .3s ease",
                            top: 0,
                            bottom: 0,
                            textAlign: "center"
                        }}
                            className="loader_btn_block">
                            <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
                        </div> : null}
                // style={{marginTop: '10px'}}
                getTheadThProps={(state, rowInfo, column, instance) => {

                    return {
                        style: {
                            borderTop: 'none',
                            borderBottom: 'none',
                            borderRight: 'none',
                            textAlign: 'center',
                            color: '#566975',
                            fontSize: '14px',
                            fontWeight: '600',
                            whiteSpace: 'nowrap',
                            float: 'left',
                        }
                    }
                }
                }
                getTrProps={(state, rowInfo, column, instance) => {
                    // onclick = () => userDetail(rowInfo ? rowInfo.row.user : rowInfo);
                    console.log(column);
                    return {
                        className: 'react-table-tr-element',
                        style: {
                            border: '1px solid #c7cdd1',
                            transition: '.3s ease-in-out',
                            width: '100%',
                            // borderRadius: '4px',
                            // height: '80px',
                            marginTop: '5px',
                            float: 'left'
                        }
                    }

                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    // if (column.Header == 'Active' || column.Header == 'Actions') {
                    if (column.id == 'image') {
                        return {
                            style: {
                                marginTop: '0px'
                            }
                        }
                    } else {
                        return {
                            className: 'react-td-element'
                        }
                    }
                }
                }

                getProps={() => {
                    return {
                        style: {
                            border: 'none'
                        }
                    }
                }}
            />
    )
}

export default CompaniesTable;